import React, { useState, useCallback } from 'react';
import Testimonial from '../components/Testimonial/Testimonial';
import CallToAction from '../components/Misc/CallToAction';
import Heading from '../components/Headers/Heading';
import ProjectsSection from '../components/ProjectComponents/ProjectsSection';
import ProjectsPagination from '../components/ProjectComponents/ProjectsPagination';

import Art from '../components/Misc/Art';
import art from '../assets/images/art_3.png';

function Projects1() {
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 1,
        totalPages: 0,
        totalStories: 0,
        hasMore: false
    });
    const [changePageFunction, setChangePageFunction] = useState(null);

    const handlePaginationChange = useCallback((info) => {
        setPaginationInfo(info);
    }, []);

    const handlePageChangeFunction = useCallback((changePageFn) => {
        setChangePageFunction(() => changePageFn);
    }, []);

    const handlePageChange = useCallback((pageNumber) => {
        if (changePageFunction) {
            changePageFunction(pageNumber);
        }
    }, [changePageFunction]);

    return (
        <>
            <Heading 
                heading={<h1>Our Rehabilitation Facility</h1>}
                headingClass="heading-very-large dark-1"
                paragraph="Our facility is designed to provide safety, structure, and comfort while supporting focus on recovery and healing."
                paragraphClass="dark-2"
                WrapperComponent={(props) => {
                    return (
                        <div className="page-header">
                            <div className="page-header-top">
                                <div className="container">
                                    {props.children}
                                </div>
                            </div>
                        </div>
                    )
                }}
            />
            {/* Impact Stories section - start */}
            <div className="projects">
                <div className="projects-header-1" style={{ background: '#fff' }}>
                    <div className="container">
                        <Heading 
                            heading={<h2>Environment & Care Highlights</h2>}
                            headingClass="heading-very-large dark-1"
                            headingColumn="col-lg-9"
                        />
                    </div>
                </div>
                <div className="projects-wrapper">
                    <ProjectsSection 
                        storiesPerPage={8}
                        type="facility"
                        onPaginationChange={handlePaginationChange}
                        onPageChange={handlePageChangeFunction}
                    />
                    <ProjectsPagination 
                        currentPage={paginationInfo.currentPage}
                        totalPages={paginationInfo.totalPages}
                        onPageChange={handlePageChange}
                        hasMore={paginationInfo.hasMore}
                    />
                </div>
            </div>
            {/* Impact Stories section - end */}
            <Testimonial type="5" />
            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Start your recovery.
                        <br />
                        Contact us today.
                    </>
                }
                buttonText="Get Help Now"
                buttonLink="/contact"
                buttonType="2"
                artwork={<Art art={art} type={'4'} />}
            />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need Support? Reach out today.</>
                }
                buttonText="Get Support"
                buttonLink="/contact"
                buttonType="1"
            />
        </>
    );
}

export default Projects1;
